import React from "react";
import Header from "../Header/Header";
import "./HeroSection.css";
import ButtonPrimary from "../UI/ButtonPrimary";
import ButtonSecondary from "../UI/ButtonSecondary";

export default function HeroSection() {
  return (
    <div className="hero-section">
      <div className="hero-section__content-area">
        <div className="hero-section__text-area">
          <div className="hero-section__primary-text">
            तपाई को मेहनत <br></br> तपाई को बचत <br></br> स्वावलम्बी को साथ
          </div>
          <div className="hero-section__secondary-text">
            आजै फोन सम्पर्क गरेर आफ्नो उज्वल <br></br>भविस्य को यात्रा आरम्भ
            गर्नु होस्
          </div>
          <div className="hero-section__cta-button">
            <ButtonSecondary
              tittle={"फोन सम्पर्क "}
              image="phone.png"
              alt="Phone Icon"
              href="tel:9844567732"
            />
          </div>
        </div>
        <div className="hero-section__image-area">
          <img
            src="assets/images/hero-image.png"
            alt="A farmer growing crops"
            className="hero-section__hero-image"
          />
        </div>
      </div>
      <img
        src="assets/images/hero-triangle.png"
        alt="Traingle just for cool looks"
        className="hero-section__triangle"
      />
      <img
        src="assets/images/thousand.png"
        alt="Thousand Nepali Rupee Note just for cool looks"
        className="hero-section__thousand"
      />
    </div>
  );
}
